import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import ReportPage from './pages/Report';
import ReporterDetailsPage from './pages/ReporterDetails';
import Videos from './pages/Videos';
import BulkReview from './pages/BulkReview';
import Appeals from './pages/Appeals';
import AppealDetail from './pages/AppealDetail';
import NotificationAnalytics from './pages/NotificationAnalytics';
import Campaigns from './pages/Campaigns';
import CampaignBuilder from './pages/CampaignBuilder';
import CampaignDetail from './pages/CampaignDetail';
import Announcements from './pages/Announcements';
import AnnouncementEditor from './pages/AnnouncementEditor';
import AISupport from './pages/AISupport';
import ImageModeration from './pages/ImageModeration';
import ExclusiveMembers from './pages/ExclusiveMembers';
import Analytics from './pages/Analytics';
import AnalyticsV2 from './pages/analytics-v2/AnalyticsV2';
import FacebookDeletion from './pages/FacebookDeletion';
import LiveAccess from './pages/LiveAccess';
import LiveAccessUserDetail from './pages/LiveAccessUserDetail';
import LiveAccessUserProfile from './pages/LiveAccessUserProfile';
import LiveSessionDetail from './pages/LiveSessionDetail';
import LiveSessionReportsDetail from './pages/LiveSessionReportsDetail';
import LiveAccessUserLivestreams from './pages/LiveAccessUserLivestreams';
import LiveAccessUserLivestreamDetail from './pages/LiveAccessUserLivestreamDetail';
import LivestreamAnalyticsDetail from './pages/LivestreamAnalyticsDetail';
import Cashout from './pages/Cashout';
import GrowthAudit from './pages/GrowthAudit';
import CashoutApplicationDetail from './pages/CashoutApplicationDetail';
import WithdrawalRequestDetail from './pages/WithdrawalRequestDetail';
import BankAccountDetail from './pages/BankAccountDetail';
import AuthProvider from './components/AuthProvider';
import VersionWatcher from './components/VersionWatcher';
const LiveReviewConsole=React.lazy(()=>import('./pages/live-review/LiveReviewConsole'));

const App: React.FC = () => {
  return (
    <AuthProvider>
      <ToastContainer position='top-center' autoClose={3000} />
      <VersionWatcher />
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/reports' element={<Reports />} />
        <Route path='/report/:reportId/:itemType' element={<ReportPage />} />
        <Route path='/reports/:itemType/:reportId/reporter/:reporterUserId' element={<ReporterDetailsPage />} />
        <Route path='/videos' element={<Videos />} />
        <Route path='/bulk-review' element={<BulkReview />} />
        <Route path='/appeals' element={<Appeals />} />
        <Route path='/appeals/:appealId' element={<AppealDetail />} />
        <Route path='/notifications' element={<NotificationAnalytics />} />
        <Route path='/campaigns' element={<Campaigns />} />
        <Route path='/campaigns/new' element={<CampaignBuilder />} />
        <Route path='/campaigns/:id' element={<CampaignDetail />} />
        <Route path='/campaigns/:id/edit' element={<CampaignBuilder />} />
        <Route path='/announcements' element={<Announcements />} />
        <Route path='/announcements/new' element={<AnnouncementEditor />} />
        <Route path='/announcements/:id/edit' element={<AnnouncementEditor />} />
        <Route path='/ai-support' element={<AISupport />} />
        <Route path='/image-moderation' element={<ImageModeration />} />
        <Route path='/exclusive-members' element={<ExclusiveMembers />} />
        <Route path='/live-access' element={<LiveAccess />} />
        <Route path='/live-review' element={<React.Suspense fallback={<p>Loading live review…</p>}><LiveReviewConsole /></React.Suspense>} />
        <Route path='/live-access/config' element={<LiveAccess />} />
        <Route path='/live-access/streams' element={<LiveAccess />} />
        <Route path='/live-access/reports' element={<LiveAccess />} />
        <Route path='/live-access/analytics' element={<LiveAccess />} />
        <Route path='/live-access/health' element={<LiveAccess />} />
        <Route path='/live-access/analytics/:sessionId' element={<LivestreamAnalyticsDetail />} />
        <Route path='/live-access/sessions/:sessionId' element={<LiveSessionDetail />} />
        <Route path='/live-access/reports/:sessionId' element={<LiveSessionReportsDetail />} />
        <Route path='/live-access/:userId' element={<LiveAccessUserDetail />} />
        <Route path='/live-access/:userId/profile' element={<LiveAccessUserProfile />} />
        <Route path='/live-access/:userId/livestreams' element={<LiveAccessUserLivestreams />} />
        <Route path='/live-access/:userId/livestreams/:sessionId' element={<LiveAccessUserLivestreamDetail />} />
        <Route path='/cashout' element={<Cashout />} />
        <Route path='/growth-audit' element={<GrowthAudit />} />
        <Route path='/cashout/withdrawals/:requestId' element={<WithdrawalRequestDetail />} />
        <Route path='/cashout/bank-accounts/:methodId' element={<BankAccountDetail />} />
        <Route path='/cashout/:userId' element={<CashoutApplicationDetail />} />
        <Route path='/analytics' element={<Analytics />} />
        <Route path='/analytics-v2' element={<AnalyticsV2 />} />
        <Route path='/facebook-deletion' element={<FacebookDeletion />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
